import { confirmToken } from 'api/accountApi';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

const ResetPasswordPage = () => {
    const { token } = useParams();

    useEffect(() => {
        const confirm = async () => {
            if (token) {
                try {
                    await confirmToken(token);
                    window.location.href = '/login?msg=reseted-password';
                } catch (error) {
                    window.location.href = '/login?msg=reseted-password';
                }
            } else {
                window.location.href = '/login?msg=reseted-password';
            }
        };

        confirm();
    }, []);

    return <></>;
};

export default ResetPasswordPage;
